
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/results",
      function () {
        return require("private-next-pages/results.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/results"])
      });
    }
  